<div class="layout-container wizard-layout-container">
  <div class="layout-content-wrapper">
    <app-wizard-topbar (closeWizard)="onCloseWizard()"></app-wizard-topbar>
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

